export const downloads: string[] = [
  'brochure',
  'install_manual',
  'specs',
  'owner_manual',
  'remote_manual',
  'warranty_doc',
  'accessory_manual_1',
  'accessory_manual_2',
  'accessory_manual_3',
  'accessory_manual_4',
  'french_brochure',
  'french_install_manual',
  'french_owner_manual',
  'french_remote_manual',
  'french_warranty_document',
  'french_accessory',
  'spanish_brochure',
  'spanish_install_manual',
  'spanish_owner_manual',
  'spanish_remote',
  'spanish_warranty',
  'spanish_accessory',
  'ahri_certs',
  'energy_guide_certs',
  'other_certs',
  'misc_doc4',
];

export const images: string[] = [
  'image_1',
  'image_2',
  'image_3',
  'image_4',
  'image_5',
  'image_6',
  'image_7',
  'image_8',
  'image_9',
  'image_10',
];

export const videos: string[] = [
  'video_1',
  'video_2',
  'video_3',
  'video_4',
  'video_5',
];

export const exclusions: string[] = [
  'id',
  'brand name',
  'gtin',
  'utpc',
  'upc',
  'series_ext',
  'short_description',
  'long_description',
  'url',
  'active',
  'date_created',
  'last_updated_date',
  'msrp',
  'technical_manual',
  'service_manual',
  'french_tech_manual',
  'french_service_manual',
  'spanish_tech_manual',
  'spanish_service_manual',
  ...downloads,
  ...images,
  ...videos,
];

export const abbreviations: string[] = [
  'msrp',
  'id',
  'gtin',
  'upc',
  'seer2',
  'eer',
  'eer2',
  'cop-47',
  'hspf-4',
  'hspf-5',
  'hspf2-4',
  'hspf2-5',
  'cfm',
];

export const units: {
  [key: string]: any;
} = {
  cfm: 'CFM',
  tonnage: 'Tons',
  btu: 'BTU',
  v: 'V',
  phase: 'Phase',
  hz: 'Hz',
  a: 'A',
  oz: 'oz',
  dba: 'dBA',
  in: 'in',
  lbs: 'lbs',
  f: 'F',
};

export function convertToTitleCase(input: string) {
  return input
    .split('-')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
}

export function formatKey(key: string, abbreviations?: string[]): string {
  const formatted = key
    .replace(/_/g, ' ')
    .replace(/\b\w/g, (char) => char.toUpperCase());

  // Format abbreviation
  if (abbreviations && abbreviations.includes(key.toLowerCase())) {
    return formatted.toUpperCase();
  }

  // Format units
  const unitMatch = key.match(/\(([^)]+)\)/);

  if (unitMatch) {
    const unit = unitMatch[1].trim().toLowerCase();
    const formattedUnit = units[unit] || unit;
    const formattedKey = formatted.replace(/\s*\(.*?\)\s*/g, '');
    return `${formattedKey} (${formattedUnit})`;
  }

  return formatted;
}

export function compareObj(obj1: any, obj2: any): any {
  const merge = Object.assign({}, obj1, obj2);
  Object.keys(merge).forEach((key) => {
    if (obj1[key]) {
      merge[key] = {
        ...(typeof merge[key] === 'object' ? merge[key] : {}),
        left: obj1[key],
      };
    }
    if (obj2[key]) {
      merge[key] = {
        ...(typeof merge[key] === 'object' ? merge[key] : {}),
        right: obj2[key],
      };
    }
  });
  return merge;
}

export const ecoRebateData: any = {
  advantage: [
    'A-09-HP-C-230B',
    'A-12-HP-C-230B',
    'A-18-HP-C-230B',
    'A-24-HP-C-230B',
    'A-09-HP-C-115B',
    'A-12-HP-C-115B',
  ],
  'olympus-e-star': [
    'O-ES-09-HP-230E',
    'O-ES-12-HP-230E',
    'O-ES-18-HP-230E',
    'O-ES-24-HP-230E',
    'O-ES-18-HP-C-230',
    'O-ES-24-HP-C-230',
    'O-ES-18-HP-230',
    'O-ES-09-HP-230',
    'O-ES-12-HP-230',
  ],
  'olympus-hyper-heat': [
    'O-HH-09-HP-230E',
    'O-HH-12-HP-230E',
    'O-HH-18-HP-230E',
    'O-HH-24-HP-230E',
  ],
  'olympus-multi-zone': [
    'MULTI2-18HP230V1',
    'MULTI3-27HP230V1',
    'MULTI4-36HP230V1',
    'MULTI5-48HP230V1',
  ],
  'universal-series': [
    'MDU18024',
    'MDU18036',
    'MDU18048',
    'MDU18060',
    'MDUI18024E',
    'MDUI18036E',
    'MDUI18048E',
    'MDUI18060E',
    'MDUCC15024',
    'MDUCC15036',
    'MDUCC15048',
    'MDUCC15060',
  ],
  'package-a-c': [
    'MPC241M414A',
    'MPC301M414A',
    'MPC361M414A',
    'MPC421M414A',
    'MPC481M414A',
    'MPC601M414A',
  ],
  'package-gas-and-electric': [
    'MPG24S054M414A',
    'MPG30S054M414A',
    'MPG36S090M414A',
    'MPG42S090M414A',
    'MPG48S108M414A',
    'MPG60S108M414A',
  ],
  'package-heat-pump': [
    'MPH241M414A',
    'MPH301M414A',
    'MPH361M414A',
    'MPH421M414A',
    'MPH481M414A',
    'MPH601M414A',
  ],
  DIYMultiZone3rdgen: ['DIY-MULTI3-27HP230', 'DIY-MULTI4-36HP230'],
  'pro-direct-series': [
    'HAC14018',
    'HAC14024',
    'HAC14030',
    'HAC14036',
    'HAC14042',
    'HAC14048',
    'HAC14060',
    'HHP14018',
    'HHP14024',
    'HHP14030',
    'HHP14036',
    'HHP14042',
    'HHP14048',
    'HHP14060',
  ],
  'diy-4th-generation': [
    'DIY-18-HP-C-230C',
    'DIY-24-HP-C-230C',
    'DIY-12-HP-C-115C',
    'DIY-36-HP-C-230C',
  ],
  DIYMultiZone4thgen: [
    'DIY-MULTI2-18HP230C',
    'DIY-MULTI3-27HP230C',
    'DIY-MULTI4-36HP230C',
    'DIY-MULTI5-48HP230C',
  ],
  'easy-pro': [
    'EZPRO-09-HP-11516',
    'EZPRO-12-HP-11516',
    'EZPRO-18-HP-23016',
    'EZPRO-24-HP-23016',
  ],
  'central-ducted-hyper-heat': [
    'CENTRAL-24-HP-C-230A00',
    'CENTRAL-36-HP-C-230A00',
    'CENTRAL-48-HP-C-230A00',
    'CENTRAL-60-HP-C-230A00',
  ],
  TanklessWaterHeaters: ['MHWH199NCLU', 'MHWH199NCNU'],
  Geothermal2ndgen: [
    'GCHPV024TGTANXR',
    'GCHPV036TGTANXR',
    'GCHPV048TGTANXR',
    'GCHPV060TGTANXR',
    'GCHPV024TGTANXL',
    'GCHPV036TGTANXL',
    'GCHPV048TGTANXL',
    'GCHPV060TGTANXL',
  ],
  'geo-cool-inverter': ['GCSHPM048IN', 'GCSHPM060IN'],
  'heat-pump-condensers': [
    'MHP15018A',
    'MHP15024A',
    'MHP15024A',
    'MHP15030A',
    'MHP15030A',
    'MHP15036A',
    'MHP15036A',
    'MHP15042A',
    'MHP15042A',
    'MHP15048A',
    'MAHM060ETA',
    'MHP15060A',
    'MHP15018A',
    'MHP15018A',
    'MHP15024A',
    'MHP15024A',
    'MHP15030A',
    'MHP15036A',
    'MHP15036A',
    'MHP15036A',
    'MHP15042A',
    'MHP15042A',
    'MHP15048A',
    'MHP15048A',
    'MHP15060A',
    'MHP15018A',
    'MHP15024A',
    'MHP15030A',
    'MHP15036A',
    'MHP15042A',
    // "MHP15042A",
    // "MHP15048A / MGM80SE090C5A / MCHP51CNPA / H4TXV02",
    // "MHP15048A / MGM80SE110C5A / MCHP51CNPA / H4TXV02",
    // "MHP15060A / MGM80SE110C5A / MCHP51CNPA / H4TXV03",
    // "MHP15018A / MGM80SE045A3A / MCVP30ANPA / H4TXV01",
    // "MHP15024A / MGM80SE070B3A / MCVP30BNPA / H4TXV01",
    // "MHP15030A / MGM80SE090B4A / MCVP30BNPA / H4TXV01",
    // "MHP15036A / MGM80SE090B4A / MCVP36BNPA / H4TXV02",
    // "MHP15042A / MGM80SE090C5A / MCVP49CNPA / H4TXV02",
    // "MHP15042A / MGM80SE110C5A / MCVP49CNPA / H4TXV02",
    // "MHP15048A / MGM80SE090C5A / MCVP60CNPA / H4TXV02",
    // "MHP15048A / MGM80SE110C5A / MCVP60CNPA / H4TXV02",
    // "MHP15060A / MGM80SE110C5A / MCVP60CNPA / H4TXV03",
    // "MHP15018A / MGM95SE045B3XA / MCHP30BNPA / H4TXV01",
    // "MHP15024A / MGM95SE070B3XA / MCHP24BNPA / H4TXV01",
    // "MHP15030A / MGM95SE070B3XA / MCHP30BNPA / H4TXV01",
    // "MHP15036A / MGM95SE090C4XA / MCHP51CNPA / H4TXV02",
    // "MHP15042A / MGM95SE090C4XA / MCHP51CNPA / H4TXV02",
    // "MHP15042A / MGM95SE110C5XA / MCHP51CNPA / H4TXV02",
    // "MHP15048A / MGM95SE090C4XA / MCHP51CNPA / H4TXV02",
    // "MHP15048A / MGM95SE110C5XA / MCHP51CNPA / H4TXV02",
    // "MHP15060A / MGM95SE110C5XA / MCHP51CNPA / H4TXV03",
    // "MHP15018A / MGM95SE045B3XA / MCVP30BNPA / H4TXV01",
    // "MHP15024A / MGM95SE070B3XA / MCVP30BNPA / H4TXV01",
    // "MHP15030A / MGM95SE070B3XA / MCVP36BNPA / H4TXV01",
    // "MHP15036A / MGM95SE090C4XA / MCVP48CNPA / H4TXV02",
    // "MHP15048A / MGM95SE090C4XA / MCVP60CNPA / H4TXV02",
    // "MHP15048A / MGM95SE110C5XA / MCVP60CNPA / H4TXV02",
    // "MHP15060A / MGM95SE110C5XA / MCVP60CNPA / H4TXV03",
  ],
  // SignatureseriesACcondenser: ["MAC16018A / MAHM018CTA", "MAC16018A / MAC16024A", "MAC16018A / MAHM030CTA" ,"MAC16024A / MAHM024CTA", "MAC16024A / MAHM030CTA", "MAC16030A / MAHM030CTA","MAC16030A / MAHM036CTA", "MAC16036A / MAHM036CTA", "MAC16036A / MAHM042CTA", "MAC16042A / MAHM042CTA", "MAC16042A / MAHM048CTA", "MAC16048A / MAHM048CTA", "MAC16048A / MAHM060CTA","MAC16060A / MAHM060CTA", "MAC16018A / MAHM024ETA", "MAC16018A / MAHM030ETA", "MAC16024A / MAHM024ETA", "MAC16024A / MAHM030ETA", "MAC16030A / MAHM030ETA", "MAC16030A / MAHM036ETA","MAC16036A / MAHM036ETA", "MAC16036A / MAHM042ETA", "MAC16042A / MAHM042ETA", "MAC16042A / MAHM048ETA", "MAC16048A / MAHM048ETA", "MAC16048A / MAHM060ETA", "MAC16060A / MAHM060ETA","MAC16018A / MGM80SE045A3A / MCHP24ANPA", "MAC16018A / MGM80SE070B3A / MCHP24BNPA", "MAC16018A / MGM80SE045A3A / MCHP30ANPA", "MAC16018A / MGM80SE070B3A / MCHP30BNPA", "MAC16024A / MGM80SE045A3A / MCHP24ANPA","MAC16024A / MGM80SE070B3A / MCHP24BNPA", "MAC16024A / MGM80SE045A3A / MCHP30ANPA", "MAC16024A / MGM80SE070B3A / MCHP30BNPA", "MAC16024A / MGM80SE070B3A / MCHP36BNPA", "MAC16030A / MGM80SE045A3A / MCHP30ANPA","MAC16030A / MGM80SE070B3A / MCHP30BNPA", "MAC16030A / MGM80SE090B4A / MCHP30BNPA", "MAC16030A / MGM80SE070B3A / MCHP36BNPA", "MAC16030A / MGM80SE090B4A / MCHP36BNPA", "MAC16036A / MGM80SE070B3A / MCHP36BNPA","MAC16036A / MGM80SE090B4A / MCHP36BNPA", "MAC16042A / MGM80SE090B4A / MCHP48BNPA", "MAC16042A / MGM80SE090C5A / MCHP48CNPA", "MAC16042A / MGM80SE110C5A / MCHP48CNPA", "MAC16048A / MGM80SE090C5A / MCHP48CNPA","MAC16048A / MGM80SE110C5A / MCHP48CNPA", "MAC16048A / MGM80SE090C5A / MCHP51CNPA", "MAC16048A / MGM80SE110C5A / MCHP51CNPA", "MAC16018A / MGM80SE045A3A / MCVP24ANPA", "MAC16018A / MGM80SE045A3A / MCVP30ANPA","MAC16018A / MGM80SE070B3A / MCVP30BNPA", "MAC16024A / MGM80SE045A3A / MCVP24ANPA", "MAC16024A / MGM80SE045A3A / MCVP30ANPA", "MAC16030A / MGM80SE045A3A / MCVP30ANPA", "MAC16030A / MGM80SE070B3A / MCVP30BNPA","MAC16030A / MGM80SE090B4A / MCVP30BNPA", "MAC16030A / MGM80SE070B3A / MCVP36BNPA", "MAC16030A / MGM80SE090B4A / MCVP36BNPA", "MAC16036A / MGM80SE070B3A / MCVP48BNPA", "MAC16036A / MGM80SE090B4A / MCVP48BNPA","MAC16036A / MGM80SE110C5A / MCVP48CNPA", "MAC16042A / MGM80SE090B4A / MCVP48BNPA", "MAC16042A / MGM80SE110C5A / MCVP48CNPA", "MAC16042A / MGM80SE110C5A / MCVP49CNPA", "MAC16048A / MGM80SE090C5A / MCVP49CNPA","MAC16048A / MGM80SE110C5A / MCVP49CNPA", "MAC16048A / MGM80SE090C5A / MCVP60CNPA", "MAC16048A / MGM80SE110C5A / MCVP60CNPA", "MAC16060A / MGM80SE090C5A / MCVP60CNPA", "MAC16060A / MGM80SE110C5A / MCVP60CNPA","MAC16018A / MGM95SE070B3XA / MCHP24BNPA", "MAC16018A / MGM95SE045B3XA / MCHP30BNPA", "MAC16018A / MGM95SE070B3XA / MCHP30BNPA", "MAC16024A / MGM95SE045B3XA / MCHP24BNPA", "MAC16024A / MGM95SE070B3XA / MCHP24BNPA","MAC16024A / MGM95SE045B3XA / MCHP30BNPA", "MAC16024A / MGM95SE070B3XA / MCHP30BNPA", "MAC16024A / MGM95SE045B3XA / MCHP36BNPA", "MAC16024A / MGM95SE070B3XA / MCHP36BNPA", "MAC16030A / MGM95SE045B3XA / MCHP30BNPA","MAC16030A / MGM95SE070B3XA / MCHP30BNPA", "MAC16030A / MGM95SE045B3XA / MCHP36BNPA", "MAC16030A / MGM95SE070B3XA / MCHP36BNPA", "MAC16042A / MGM95SE110C5XA / MCHP48CNPA", "MAC16048A / MGM95SE090C4XA / MCHP48CNPA","MAC16048A / MGM95SE110C5XA / MCHP48CNPA", "MAC16048A / MGM95SE090C4XA / MCHP51CNPA", "MAC16048A / MGM95SE110C5XA / MCHP51CNPA", "MAC16018A / MGM95SE045B3XA / MCVP30BNPA", "MAC16018A / MGM95SE070B3XA / MCVP30BNPA","MAC16030A / MGM95SE045B3XA / MCVP30BNPA", "MAC16030A / MGM95SE070B3XA / MCVP30BNPA", "MAC16030A / MGM95SE045B3XA / MCVP36BNPA", "MAC16030A / MGM95SE070B3XA / MCVP36BNPA", "MAC16036A / MGM95SE090C4XA / MCVP48CNPA","MAC16036A / MGM95SE110C5XA / MCVP48CNPA", "MAC16042A / MGM95SE090C4XA / MCVP48CNPA", "MAC16042A / MGM95SE090C4XA / MCVP49CNPA", "MAC16048A / MGM95SE090C4XA / MCVP49CNPA", "MAC16048A / MGM95SE110C5XA / MCVP49CNPA","MAC16048A / MGM95SE090C4XA / MCVP60CNPA", "MAC16048A / MGM95SE110C5XA / MCVP60CNPA", "MAC16060A / MGM95SE110C5XA / MCVP60CNPA", "MAC16018A / MGM80SE045A3A / MCHP24ANPA / H4TXV01", "MAC16018A / MGM80SE070B3A / MCHP24BNPA / H4TXV01","MAC16018A / MGM80SE045A3A / MCHP30ANPA / H4TXV01", "MAC16018A / MGM80SE070B3A / MCHP30BNPA / H4TXV01", "MAC16024A / MGM80SE045A3A / MCHP24ANPA / H4TXV01", "MAC16024A / MGM80SE070B3A / MCHP24BNPA / H4TXV01","MAC16024A / MGM80SE045A3A / MCHP30ANPA / H4TXV01", "MAC16024A / MGM80SE070B3A / MCHP30BNPA / H4TXV01", "MAC16024A / MGM80SE070B3A / MCHP36BNPA / H4TXV01", "MAC16030A / MGM80SE045A3A / MCHP30ANPA / H4TXV01","MAC16030A / MGM80SE070B3A / MCHP30BNPA / H4TXV01", "MAC16030A / MGM80SE090B4A / MCHP30BNPA / H4TXV01", "MAC16030A / MGM80SE070B3A / MCHP36BNPA / H4TXV01", "MAC16030A / MGM80SE090B4A / MCHP36BNPA / H4TXV01","MAC16036A / MGM80SE070B3A / MCHP36BNPA / H4TXV01", "MAC16036A / MGM80SE090B4A / MCHP36BNPA / H4TXV01", "MAC16042A / MGM80SE090B4A / MCHP48BNPA / H4TXV02", "MAC16042A / MGM80SE090C5A / MCHP48CNPA / H4TXV02","MAC16042A / MGM80SE110C5A / MCHP48CNPA / H4TXV02", "MAC16048A / MGM80SE090C5A / MCHP48CNPA / H4TXV02", "MAC16048A / MGM80SE110C5A / MCHP48CNPA / H4TXV02", "MAC16048A / MGM80SE090C5A / MCHP51CNPA / H4TXV02","MAC16048A / MGM80SE110C5A / MCHP51CNPA / H4TXV02", "MAC16060A / MGM80SE110C5A / MCHP51CNPA / H4TXV03", "MAC16060A / MGM80SE135D5A / MCHP60DNPA / H4TXV03", "MAC16018A / MGM80SE045A3A / MCVP24ANPA / H4TXV01","MAC16018A / MGM80SE045A3A / MCVP30ANPA / H4TXV01", "MAC16024A / MGM80SE070B3A / MCVP24BNPA / H4TXV01", "MAC16024A / MGM80SE045A3A / MCVP30BNPA / H4TXV01", "MAC16024A / MGM80SE070B3A / MCVP30BNPA / H4TXV01","MAC16024A / MGM80SE070B3A / MCVP36BNPA / H4TXV01", "MAC16030A / MGM80SE045A3A / MCVP30ANPA / H4TXV01", "MAC16030A / MGM80SE070B3A / MCVP30BNPA / H4TXV01", "MAC16030A / MGM80SE090B4A / MCVP30BNPA / H4TXV01","MAC16030A / MGM80SE070B3A / MCVP36BNPA / H4TXV01", "MAC16030A / MGM80SE090B4A / MCVP36BNPA / H4TXV01", "MAC16036A / MGM80SE070B3A / MCVP36BNPA / H4TXV02", "MAC16036A / MGM80SE090B4A / MCVP36BNPA / H4TXV02","MAC16036A / MGM80SE070B3A / MCVP48BNPA / H4TXV02", "MAC16036A / MGM80SE090B4A / MCVP48BNPA / H4TXV02", "MAC16036A / MGM80SE090C5A / MCVP48CNPA / H4TXV02", "MAC16036A / MGM80SE110C5A / MCVP48CNPA / H4TXV02","MAC16042A / MGM80SE090B4A / MCVP48BNPA / H4TXV02", "MAC16042A / MGM80SE110C5A / MCVP48CNPA / H4TXV02", "MAC16042A / MGM80SE110C5A / MCVP49CNPA / H4TXV02", "MAC16048A / MGM80SE090C5A / MCVP49CNPA / H4TXV02","MAC16048A / MGM80SE110C5A / MCVP49CNPA / H4TXV02", "MAC16048A / MGM80SE090C5A / MCVP60CNPA / H4TXV02", "MAC16048A / MGM80SE110C5A / MCVP60CNPA / H4TXV02", "MAC16060A / MGM80SE090C5A / MCVP60CNPA / H4TXV03","MAC16060A / MGM80SE110C5A / MCVP60CNPA / H4TXV03", "MAC16018A / MGM95SE070B3XA / MCHP24BNPA / H4TXV01", "MAC16018A / MGM95SE045B3XA / MCHP30BNPA / H4TXV01", "MAC16018A / MGM95SE070B3XA / MCHP30BNPA / H4TXV01","MAC16024A / MGM95SE045B3XA / MCHP24BNPA / H4TXV01", "MAC16024A / MGM95SE070B3XA / MCHP24BNPA / H4TXV01", "MAC16024A / MGM95SE045B3XA / MCHP30BNPA / H4TXV01", "MAC16024A / MGM95SE070B3XA / MCHP30BNPA / H4TXV01","MAC16024A / MGM95SE045B3XA / MCHP36BNPA / H4TXV01", "MAC16024A / MGM95SE070B3XA / MCHP36BNPA / H4TXV01", "MAC16030A / MGM95SE045B3XA / MCHP30BNPA / H4TXV01", "MAC16030A / MGM95SE070B3XA / MCHP30BNPA / H4TXV01","MAC16030A / MGM95SE045B3XA / MCHP36BNPA / H4TXV01", "MAC16030A / MGM95SE070B3XA / MCHP36BNPA / H4TXV01", "MAC16042A / MGM95SE110C5XA / MCHP48CNPA / H4XTV02", "MAC16036A / MGM95SE045B3XA / MCHP36BNPA / H4TXV01","MAC16036A / MGM95SE070B3XA / MCHP36BNPA / H4TXV01", "MAC16048A / MGM95SE090C4XA / MCHP48CNPA / H4TXV02", "MAC16048A / MGM95SE110C5XA / MCHP48CNPA / H4TXV02", "MAC16048A / MGM95SE090C4XA / MCHP51CNPA / H4TXV02","MAC16048A / MGM95SE110C5XA / MCHP51CNPA / H4TXV02", "MAC16060A / MGM95SE110C5XA / MCHP51CNPA / H4TXV02", "MAC16018A / MGM95SE045B3XA / MCVP30BNPA / H4TXV01", "MAC16024A / MGM95SE045B3XA / MCVP24BNPA / H4TXV01","MAC16024A / MGM95SE070B3XA / MCVP24BNPA / H4TXV01", "MAC16024A / MGM95SE045B3XA / MCVP30BNPA / H4TXV01", "MAC16024A / MGM95SE070B3XA / MCVP30BNPA / H4TXV01", "MAC16024A / MGM95SE045B3XA / MCVP36BNPA / H4TXV01","MAC16024A / MGM95SE070B3XA / MCVP36BNPA / H4TXV01", "MAC16030A / MGM95SE045B3XA / MCVP36BNPA / H4TXV01", "MAC16030A / MGM95SE070B3XA / MCVP36BNPA / H4TXV01", "MAC16036A / MGM95SE045B3XA / MCVP36BNPA / H4TXV02","MAC16036A / MGM95SE070B3XA / MCVP36BNPA / H4TXV02", "MAC16036A / MGM95SE045B3XA / MCVP48BNPA / H4TXV02", "MAC16036A / MGM95SE070B3XA / MCVP48BNPA / H4TXV02", "MAC16036A / MGM95SE090C4XA / MCVP48CNPA / H4TXV02","MAC16036A / MGM95SE110C5XA / MCVP48CNPA / H4TXV02", "MAC16042A / MGM95SE090C4XA / MCVP48CNPA / H4TXV02", "MAC16042A / MGM95SE090C4XA / MCVP49CNPA / H4TXV02", "MAC16048A / MGM95SE090C4XA / MCVP49CNPA / H4TXV02","MAC16048A / MGM95SE110C5XA / MCVP49CNPA / H4TXV02", "MAC16048A / MGM95SE090C4XA / MCVP60CNPA / H4TXV02", "MAC16048A / MGM95SE110C5XA / MCVP60CNPA / H4TXV02", "MAC16060A / MGM95SE110C5XA / MCVP60CNPA / H4TXV03"]
};
